import React, { useState } from "react";
import styles from "./nav.module.css";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link } from "react-scroll";
import { Col, Container, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  const [openMenu, setOpenMenu] = useState(false);

  const handleClick = () => {
    setOpenMenu(!openMenu);
  };
  return (
    <React.Fragment>
      <nav className={styles.navbar}>
        <Container fluid>
          <Row>
            <Col md={2}>
              <div className={styles.Image_section}>
                <NavLink to={"/"}>
                  <img src="/logo.png" className={styles.logo_image} alt="Logo - Buildshell" />
                </NavLink>
              </div>
            </Col>
            <Col md={8} className="d-flex align-items-center">
              <div className={`${styles.nav_item}`}>
                <Link to={"about"} smooth={true} duration={500}>About us</Link>
                <Link to={"program"} smooth={true} duration={500} >Services</Link>
                <Link to={"vertical"} smooth={true} duration={500}>Vertices</Link>
                {/* <Link to={"packages"} smooth={true} duration={500}>Projects</Link> */}
                <Link to={"policies"} smooth={true} duration={500}>Testimonials</Link>
                {/* <Link to={"scheme"} smooth={true} duration={500}>Schemes & Policies</Link> */}
                <Link to={"faq"} smooth={true} duration={500}>FAQs</Link>
              </div>
            </Col>
            <Col md={2} className="d-flex align-items-center justify-content-center">
              <div className={styles.btn_section}>
                <button className={styles.connectBtn}>Connect with us</button>
              </div>
            </Col>
          </Row>
        </Container>
      </nav>

      {/* --------responsive-menu------- */}
      <>
        <div className={styles.mobile_responsive}>
          <div className={styles.logo}>
            <Link to={"/"}>
              <img src="/images/Homepage/icon.png" className={styles.logo_image} alt="Logo - Buildshell" />
            </Link>
          </div>
          <GiHamburgerMenu
            onClick={handleClick}
            size={34}
            className="text-black"
          />
        </div>
        <>
          {openMenu && (
            <div className={`${styles.nav_item2}`}>
              <Link to={"about"} smooth={true} duration={500}>About us</Link>
              <Link to={"program"} smooth={true} duration={500} >Services</Link>
              <Link to={"vertical"} smooth={true} duration={500}>Vertices</Link>
              {/* <Link to={"packages"} smooth={true} duration={500}>Projects</Link> */}
              <Link to={"policies"} smooth={true} duration={500}>Testimonials</Link>
              <Link to={"faq"} smooth={true} duration={500}>FAQs</Link>
            </div>
          )}
        </>
      </>
    </React.Fragment>
  );
};

export default Navbar;
